import { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import { PageHero, Section } from "@/components/kit";
import { Eyebrow } from "@/lib/anim";
import { authAxios } from "@/lib/auth";

const TABS = [
  { key: "contacts", label: "Contacts", cols: [["name", "Name"], ["email", "Email"], ["phone", "Phone"], ["company", "Business"], ["message", "Message"]] },
  { key: "fit_calls", label: "Fit calls", cols: [["name", "Name"], ["email", "Email"], ["phone", "Phone"], ["business", "Business"], ["stage", "Stage"], ["budget", "Budget"], ["priority", "Priority"]] },
  { key: "newsletter", label: "Newsletter", cols: [["name", "Name"], ["email", "Email"], ["phone", "Phone"]] },
  { key: "calculator", label: "Calculator", cols: [["name", "Name"], ["email", "Email"]] },
  { key: "downloads", label: "Downloads", cols: [["name", "Name"], ["email", "Email"], ["slug", "Guide"]] },
];

const fmtDate = (s) => { try { return new Date(s).toLocaleString("en-AU"); } catch { return s || "-"; } };

export default function Admin() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [tab, setTab] = useState("contacts");

  useEffect(() => {
    // eslint-disable-next-line -- loads leads once on mount
    authAxios.get("/admin/leads").then((r) => setData(r.data)).catch((e) => setErr(e.response?.data?.detail || "Could not load leads."));
  }, []);

  const active = TABS.find((t) => t.key === tab);
  const rows = data ? (data[tab] || []) : [];

  return (
    <>
      <Seo title="Admin" canonical="/admin" description="Prox admin dashboard." />
      <PageHero eyebrow="Admin" crumbs={[{ label: "Home", to: "/" }, { label: "Admin" }]} title="Leads dashboard." lead="Everything captured from the site, newest first." />
      <Section bg="bone">
        {err && <p className="t-sm text-[#a24f3a]" data-testid="admin-error">{err}</p>}

        {/* counts */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-testid="admin-counts">
          {TABS.map((t) => (
            <button key={t.key} onClick={() => setTab(t.key)} data-testid={`admin-count-${t.key}`}
              className="card p-5 text-left" style={{ borderColor: tab === t.key ? "var(--clay)" : undefined }}>
              <div className="t-stat" style={{ fontSize: "clamp(26px,3vw,36px)" }}>{data ? (data.counts?.[t.key] ?? 0) : "—"}</div>
              <p className="t-caption text-[var(--muted)] mt-1">{t.label}</p>
            </button>
          ))}
        </div>

        {/* table */}
        <div className="mt-10">
          <Eyebrow>{active.label}</Eyebrow>
          <div className="mt-4 overflow-x-auto card" data-testid="admin-table">
            <table className="w-full text-left" style={{ borderCollapse: "collapse" }}>
              <thead>
                <tr className="border-b border-[var(--stone)]">
                  {active.cols.map(([, h]) => <th key={h} className="t-caption font-mono uppercase tracking-wide text-[var(--muted)] px-4 py-3 whitespace-nowrap">{h}</th>)}
                  <th className="t-caption font-mono uppercase tracking-wide text-[var(--muted)] px-4 py-3 whitespace-nowrap">When</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 && (
                  <tr><td className="px-4 py-6 t-sm text-[var(--muted)]" colSpan={active.cols.length + 1}>{data ? "No entries yet." : "Loading\u2026"}</td></tr>
                )}
                {rows.map((r) => (
                  <tr key={r.id} className="border-b border-[var(--stone)]/60 align-top">
                    {active.cols.map(([k]) => <td key={k} className="px-4 py-3 t-sm max-w-[280px]">{String(r[k] ?? "-")}</td>)}
                    <td className="px-4 py-3 t-sm text-[var(--muted)] whitespace-nowrap">{fmtDate(r.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Section>
    </>
  );
}
